import {
  VERIFY_EMAIL_REQUEST,
  VERIFY_EMAIL_SUCCESS,
  VERIFY_EMAIL_FAILURE,
  REISSUE_TOKEN_REQUEST,
  REISSUE_TOKEN_SUCCESS,
  REISSUE_TOKEN_FAILURE,
} from '../constants/actionTypes'

const initialState = {
  isVerifying: false,
  isReissuing: false,
}

export default function(state = initialState, action) {
  switch (action.type) {
    case VERIFY_EMAIL_REQUEST:
      return {
        ...state,
        isVerifying: action.isVerifying,
        errorMessage: '',
      }
    case VERIFY_EMAIL_SUCCESS:
      return {
        ...state,
        isVerifying: action.isVerifying,
      }
    case VERIFY_EMAIL_FAILURE:
      return {
        ...state,
        isVerifying: action.isVerifying,
        errorMessage: action.message,
      }
    case REISSUE_TOKEN_REQUEST:
      return {
        ...state,
        isReissuing: action.isReissuing,
        errorMessage: '',
      }
    case REISSUE_TOKEN_SUCCESS:
      return {
        ...state,
        isReissuing: action.isReissuing,
      }
    case REISSUE_TOKEN_FAILURE:
      return {
        ...state,
        isReissuing: action.isReissuing,
        errorMessage: action.message,
      }
    default:
      return state
  }
};
